function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.78313 11.7943L6.21867 9.08716C5.92001 8.83844 5.92847 8.4107 6.23678 8.17173C6.49846 7.9689 6.88719 7.97478 7.14117 8.18543L9.5 10.7132L11.8588 8.18543C12.1128 7.97478 12.5015 7.9689 12.7632 8.17173C13.0715 8.4107 13.08 8.83844 12.7813 9.08716L10.2169 11.7943C10.2169 11.7943 9.9237 12.0234 9.5 12.0234C9.0763 12.0234 8.78313 11.7943 8.78313 11.7943Z",
  fill: "#626262"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.78313 11.7943L6.21867 9.08716C5.92001 8.83844 5.92847 8.4107 6.23678 8.17173C6.49846 7.9689 6.88719 7.97478 7.14117 8.18543L9.5 10.7132L11.8588 8.18543C12.1128 7.97478 12.5015 7.9689 12.7632 8.17173C13.0715 8.4107 13.08 8.83844 12.7813 9.08716L10.2169 11.7943C10.2169 11.7943 9.9237 12.0234 9.5 12.0234C9.0763 12.0234 8.78313 11.7943 8.78313 11.7943Z",
  fill: "#69707D"
});

const SvgArrowDown = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgArrowDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow_down.e650d120.svg";
export { ForwardRef as ReactComponent };